import React from 'react';

import './PageUiNavBar.scss';
import { browserHistory } from '../../../browserHistory';

declare interface NavBarItem {
  text: string;
  active?: boolean;
  method?: () => void;
  page?: string;
}

function isBarActive(page?: string, active?: boolean): boolean {
  if (active) {
    return active;
  } else if (page) {
    return browserHistory.location.pathname === page;
  } else {
    return false;
  }
}

export function PageUiNavBar({ bars }: { bars: NavBarItem[] }): JSX.Element {
  function handleClick(url: string) {
    browserHistory.push(url);
  }

  return (
    <div className="pageuinavbar">
      {bars.map((item: NavBarItem, index: number) => {
        const isActive: boolean = isBarActive(item.page, item.active);

        return (
          <a
            className={isActive ? 'barText is-active' : 'barText'}
            key={item.text}
            onClick={e => {
              if (e.ctrlKey || e.metaKey) {
                return;
              }
              e.preventDefault();
              if (item.text === 'Monitor' && e.shiftKey) {
                handleClick(`${item.page}-old`);
              } else {
                item.method ? item.method() : handleClick(item.page);
              }
            }}
            href={item.page ? item.page : ''}
          >
            {item.text}
          </a>
        );
      })}
    </div>
  );
}
